"use client";

import { TypeFullscreenImage } from "@contentful/types";
import Image from "next/image";

export function FullscreenImage({
  fullscreenImage,
}: {
  fullscreenImage: TypeFullscreenImage<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  const imageUrl = fullscreenImage.fields.image?.fields.file?.url;
  const mobileImageUrl = fullscreenImage.fields.mobileImage?.fields.file?.url;
  const altText = fullscreenImage.fields.altText || "";

  const imageWidth =
    fullscreenImage.fields.image?.fields.file?.details.image?.width;
  const imageHeight =
    fullscreenImage.fields.image?.fields.file?.details.image?.height;

  const mobileImageWidth =
    fullscreenImage.fields.mobileImage?.fields.file?.details.image?.width;
  const mobileImageHeight =
    fullscreenImage.fields.mobileImage?.fields.file?.details.image?.height;

  if (!imageUrl) {
    return null;
  }

  // Ensure the URLs have https protocol
  const fullImageUrl = imageUrl.startsWith("//")
    ? `https:${imageUrl}`
    : imageUrl;

  const fullMobileImageUrl = mobileImageUrl?.startsWith("//")
    ? `https:${mobileImageUrl}`
    : mobileImageUrl;

  // If no mobile image is provided, fall back to the desktop image
  const displayMobileImageUrl = fullMobileImageUrl || fullImageUrl;
  const displayMobileImageWidth = mobileImageWidth || imageWidth;
  const displayMobileImageHeight = mobileImageHeight || imageHeight;

  return (
    <div className="relative w-full">
      {/* Desktop image */}
      <Image
        src={fullImageUrl}
        alt={altText}
        width={imageWidth || 1920}
        height={imageHeight || 1080}
        className="hidden h-auto w-full md:block"
        priority={false}
        quality={90}
        sizes="100vw"
      />

      {/* Mobile image (or fallback to desktop) */}
      <Image
        src={displayMobileImageUrl}
        alt={altText}
        width={displayMobileImageWidth || 768}
        height={displayMobileImageHeight || 1024}
        className="block h-auto w-full md:hidden"
        priority={false}
        quality={90}
        sizes="100vw"
      />
    </div>
  );
}
